import React from 'react';
interface ExpandIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function ExpandIcon({
	width = 16,
	height = 16,
	viewBox = '0 0 16 16',
	fill = 'currentColor',
	...props
}: Readonly<ExpandIconProps>): JSX.Element {
	return (
		<svg {...props} fill="none" width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.38037 8.54622C8.5756 8.35112 8.89217 8.35113 9.0874 8.54622L12.7671 12.2259V9.12044C12.7672 8.84442 12.991 8.62044 13.2671 8.62044C13.5431 8.62044 13.7669 8.84442 13.7671 9.12044V13.4336C13.767 13.7096 13.5432 13.9336 13.2671 13.9336H8.93376C8.6577 13.9336 8.43389 13.7096 8.43376 13.4336C8.43376 13.1575 8.65761 12.9336 8.93376 12.9336H12.0601L8.38037 9.25326C8.18523 9.05798 8.18514 8.74144 8.38037 8.54622ZM1.8335 6.8125V2.5C1.8335 2.22386 2.05735 2 2.3335 2H6.66683C6.94297 2 7.16683 2.22386 7.16683 2.5C7.16683 2.77614 6.94297 3 6.66683 3H3.57113L7.1473 6.45312C7.34594 6.64491 7.35208 6.96149 7.16032 7.16016C6.96859 7.35874 6.65196 7.3641 6.45329 7.17253L2.8335 3.67773V6.8125C2.8335 7.08864 2.60964 7.3125 2.3335 7.3125C2.05735 7.3125 1.8335 7.08864 1.8335 6.8125Z"
				fill={fill}
			/>
		</svg>
	);
}
